module.exports = __webpack_public_path__ + "static/media/butcher-boy.932d0159.jpeg";